module.exports = __webpack_public_path__ + "static/media/bag.70b8880a.png";